// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Select from "react-select";
// import CloseSharpIcon from "@mui/icons-material/CloseSharp";
// import {
//   delete_icon,
//   dummyimage,
//   edit_icon,
//   Search_icon,
//   view_icon,
// } from "../../assets/img";
// import { Table } from "../../components/Table/Table";
// import DateRange from "../../components/DateRange/DateRange";
// import Topbar from "../../components/Topbar/Topbar";
// import DateRange1 from "../../components/DateRange/DateRange1";
// import { URLS } from "../../Services/Constant";
// import { get, post } from "../../Services/ApiHandler";
// import { useGlobalContext } from "../../Services/PaginationGlobal";

// function useDebounce(value, delay) {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const handler = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(handler);
//   }, [value, delay]);
//   return debounced;
// }

// const Rooms_block = () => {
//   const inputRef = useRef(null);
//   const { paginationData, setpaginationData } = useGlobalContext();
//   const location = useLocation();

//   const path = location.pathname?.replace("/", "");

//   const navigate = useNavigate();
//   const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
//   const [pagination, setPagination] = useState("");
//   const [optionsList, setOptionsList] = useState({ state: null, city: null });
//   // const [page, setPage] = useState();
//   const [locationList, setLocationsList] = useState({ states: [], cities: [] });
//   const [city, setCity] = useState();
//   const [isBlockDate, setIsBlockDate] = useState([]);
//   const [selectedFilter, setSelectedFilter] = useState({
//     city: "",
//     state: "",
//     search: paginationData?.[path]?.search ?? "",
//     date: "",
//   });
//   const debouncedSearch = useDebounce(selectedFilter.search, 350);

//   const getBlockDate = async () => {
//     try {
//       const res = await get(URLS.ALL_BLOCKDATE);
//       if (res?.status === "success") {
//         setIsBlockDate(res?.blocked_dates); // use actual data
//       } else {
//         // setIsBlockDate([]); // fallback if no success
//       }
//     } catch (error) {
//       console.error("Error fetching block dates:", error);
//       setIsBlockDate([]); // fallback in case of error
//     }
//   };

//   useEffect(() => {
//     getBlockDate();
//   }, []);

//   const getLocationsList = async (type, parent_id) => {
//     let url = `${URLS.LOCATION}?type=${type}${
//       parent_id ? `&parent_id=${parent_id}` : ""
//     }`;
//     const res = await get(url);
//     if (res?.status === "success") {
//       const modifiedList = res.data.map((item) => ({
//         value: item.id,
//         label: item.name,
//       }));
//       if (type === 2)
//         setLocationsList((prev) => ({ ...prev, states: modifiedList }));
//       else if (type === 3)
//         setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
//     }
//   };
//   useEffect(() => {
//     getLocationsList(2);
//   }, []);
//   const [owners, setOwners] = useState([]);
//   console.log("locationList", locationList?.states);
//   const columns = React.useMemo(
//     () => [
//       {
//         Header: "S.No",
//         accessor: "",
//         Cell: ({ value, row }) => {
//           return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
//         },
//       },
//       {
//         Header: "Property",
//         accessor: "name",
//         Cell: ({ value, row }) => {
//           return (
//             <div>
//               <p style={{ color: "#AE55F5", fontWeight: "600", width: "50px" }}>
//                 {value}
//               </p>
//             </div>
//           );
//         },
//       },
//       {
//         Header: " Hotel Categories",
//         accessor: "category_name",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "Service Categories",
//         accessor: "ServiceCategories",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "State",
//         accessor: "state",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "City",
//         accessor: "city",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "Blocked on",
//         accessor: "Blockedon",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "Blocked by",
//         accessor: "Blockedby",
//         Cell: ({ value, row }) => {
//           return <p>{value}</p>;
//         },
//       },
//       {
//         Header: "Action",
//         accessor: "",
//         Cell: ({ value, row }) => {
//           return (
//             <React.Fragment>
//               <div className="d-flex ac-js gap-3">
//                 <button
//                   onClick={() => {
//                     navigate("/rooms-block-view", {
//                       state: { type: "view", value: row?.original },
//                     });
//                   }}
//                   className="cust-btn "
//                 >
//                   <img src={view_icon} alt="" className="mx-2 edit-btn " />
//                 </button>
//               </div>
//             </React.Fragment>
//           );
//         },
//       },
//     ],
//     []
//   );
//   const handleStateSelect = (selected) => {
//     setOptionsList({ state: selected, city: null });
//     handleChangeFilter("state", selected?.value || "");
//     setLocationsList((prev) => ({ ...prev, cities: [] }));
//     if (selected?.value) getLocationsList(3, selected.value);
//   };
//   const handleChangeFilter = (name, val) => {
//     if (name == "from_date") {
//       setSelectedFilter((prev) => ({
//         ...prev,
//         date: new Date(val).toLocaleDateString("en-CA"),
//       }));
//     }
//     setSelectedFilter((prev) => ({ ...prev, [name]: val }));
//     setPage(1);
//   };
//   const getList = async (pageNumber = 1) => {
//     let req = { ...selectedFilter, search: debouncedSearch };
//     const res = await post(`${URLS.ROOMS_BLOCK_LIST}?page=${pageNumber}`, req);
//     if (res?.status === "success") {
//       setPagination({ current_page: pageNumber, last_page: res?.total_pages });
//       setOwners(res?.data || []);
//     }
//   };
//   useEffect(() => {
//     getList(page);
//     setpaginationData((prev) => ({
//       ...prev,
//       [path]: { page, search: selectedFilter.search },
//     }));
//   }, [
//     selectedFilter.state,
//     selectedFilter.city,
//     debouncedSearch,
//     page,
//     selectedFilter.from_date,
//     selectedFilter.to_date,
//   ]);

//   console.log("isBlockDate", isBlockDate);
//   return (
//     <div>
//       <Topbar header={"Block"} subHead={"Rooms"} />
//       <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
//         Total:2
//       </h2>
//       <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
//         <DateRange1
//           setFromDate={(date) => {
//             handleChangeFilter("from_date", date);
//           }}
//           holidays={isBlockDate}
//         />
//         <div className="d-flex ac-jc">
//           <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
//             State :{" "}
//           </label>
//           <Select
//             className="location-search"
//             options={locationList?.states}
//             value={city}
//             // onChange={() => getLocationsList(3)}
//             // value={optionsList.state}
//             onChange={handleStateSelect}
//             placeholder={"State"}
//           />
//         </div>
//         <div className="d-flex ac-jc">
//           <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
//             City :{" "}
//           </label>

//           <Select
//             className="location-search"
//             options={locationList?.cities}
//             value={city}
//             // onChange={setCity}
//             onChange={handleStateSelect}
//             placeholder={"City"}
//             isClearable
//           />
//         </div>

//         <div className="search-input">
//           <input
//             type="text"
//             placeholder="Search Here"
//             onChange={(e) => handleChangeFilter("search", e.target.value)}
//             value={selectedFilter.search}
//             style={{ border: "none", width: "150px" }}
//           />
//           <img src={Search_icon} className="search" />
//         </div>
//       </div>

//       {/* {owners.length === 0 ? (
//         <div>No Record Found</div>
//       ) : ( */}
//       <Table
//         columns={columns}
//         setPageno={setPage}
//         pagecount={pagination}
//         data={owners}
//         show={true}
//       />
//     </div>
//   );
// };

// export default Rooms_block;
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import DateRange1 from "../../components/DateRange/DateRange1";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { checkPermission } from "../redux/api/PermissionManager";

function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);
  return debounced;
}

const Rooms_block = () => {
  const inputRef = useRef(null);
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();

  const path = location.pathname?.replace("/", "");

  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState("");
  const [isDates, setIsDates] = useState();
  const [optionsList, setOptionsList] = useState({ state: null, city: null });
  const [locationList, setLocationsList] = useState({ states: [], cities: [] });
  const [isBlockDate, setIsBlockDate] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    city: "",
    state: "",
    search: paginationData?.[path]?.search ?? "",
    date: new Date().toISOString().split("T")[0],
  });
  const debouncedSearch = useDebounce(selectedFilter.search, 350);

  const getBlockDate = async () => {
    try {
      const res = await get(URLS.ALL_BLOCKDATE);
      if (res?.status === "success") {
        setIsBlockDate(res?.blocked_dates);
      }
    } catch (error) {
      console.error("Error fetching block dates:", error);
      setIsBlockDate([]);
    }
  };

  useEffect(() => {
    getBlockDate();
  }, []);

  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${
      parent_id ? `&parent_id=${parent_id}` : ""
    }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2)
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      else if (type === 3)
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  useEffect(() => {
    getLocationsList(2);
  }, []);

  const [owners, setOwners] = useState([]);
  const [isowners, setIsOwners] = useState([]);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{row.index + 1 + (page - 1) * 10}</p>;
        },
      },
      {
        Header: "Property",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div style={{ width: "150px" }}>
              <p
                className="w-100"
                style={{ color: "#AE55F5", fontWeight: "600", width: "50px" }}
              >
                {value}
              </p>

              <p
                className="w-100"
                style={{ color: "#AE55F5", fontWeight: "600", width: "50px" }}
              >
                {row.original.code || "-"}
              </p>
            </div>
          );
        },
      },
      {
        Header: " Hotel Categories",
        accessor: "category_name",
        Cell: ({ value, row }) => {
          return <p style={{ width: "150px" }}>{value}</p>;
        },
      },
      {
        Header: "Service Categories",
        accessor: "service_categories",
        Cell: ({ value, row }) => {
          console.log("VALKJKJDSF", value, row);

          return <p>{value}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Blocked on",
        accessor: "blocked_on",
        Cell: ({ value, row }) => {
          console.log("VLAAAAAA", value);
          const [year, month, day] = value.split("-");
          const formatDate = (dateString) => {
            const [year, month, day] = dateString.split("-");
            return `${day}/${month}/${year}`;
          };

          console.log("SDKLASLKDKAS", day / month / year);

          return <p>{value && formatDate(value)}</p>;
        },
      },
      {
        Header: "Blocked by",
        accessor: "blocked_by",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/rooms-block-view", {
                    state: {
                      type: "view",
                      value: row?.original,
                      selectedFilter: selectedFilter,
                    },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </>
        );
      },
    };
    return checkPermission("CAN-VIEW-ROOMS") ||
      checkPermission("CAN-EDIT-ROOMS")
      ? [...d, action]
      : d;
  }, [page, selectedFilter]);

  const handleStateSelect = (selected) => {
    setOptionsList({ state: selected, city: null });
    handleChangeFilter("state", selected?.value || "");
    setLocationsList((prev) => ({ ...prev, cities: [] }));
    if (selected?.value) getLocationsList(3, selected.value);
  };

  const handleCitySelect = (selected) => {
    setOptionsList((prev) => ({ ...prev, city: selected }));
    handleChangeFilter("city", selected?.value || "");
  };

  const handleChangeFilter = (name, val) => {
    if (name === "from_date") {
      setSelectedFilter((prev) => ({
        ...prev,
        date: new Date(val).toLocaleDateString("en-CA"),
      }));
    }
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));

    setPage(1);
  };

  const getList = async (pageNumber = 1) => {
    let req = { ...selectedFilter, search: debouncedSearch };
    const res = await post(`${URLS.ROOMS_BLOCK_LIST}?page=${pageNumber}`, req);
    if (res?.status === "success") {
      setPagination({ current_page: pageNumber, last_page: res?.total_pages });
      setOwners(res?.data || []);
      setIsOwners(res);
    }
  };

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.state,
    selectedFilter.city,
    debouncedSearch,
    page,
    selectedFilter.from_date,
    selectedFilter.to_date,
  ]);
  console.log("owners_KKSAD", selectedFilter);
  return (
    <div>
      <Topbar header={"Block"} subHead={"Rooms"} />
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{isowners?.total_pages}
      </h2>
      <div className="d-flex ac-js mt-3 gap-4 flex-wrap">
        <DateRange1
          setFromDate={(date) => {
            handleChangeFilter("from_date", date);
            setIsDates(date);
          }}
          holidays={isBlockDate}
        />
        <div className="d-flex ac-jc">
          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
            State :{" "}
          </label>
          <Select
            className="location-search"
            options={locationList?.states}
            value={optionsList.state}
            onChange={handleStateSelect}
            placeholder={"State"}
            isClearable
          />
        </div>
        <div className="d-flex ac-jc">
          <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20">
            City :{" "}
          </label>
          <Select
            className="location-search"
            options={locationList?.cities}
            value={optionsList.city}
            onChange={handleCitySelect}
            placeholder={"City"}
            isClearable
          />
        </div>

        <div className="search-input">
          <input
            type="text"
            placeholder="Search Here"
            onChange={(e) => handleChangeFilter("search", e.target.value)}
            value={selectedFilter.search}
            style={{ border: "none", width: "150px" }}
          />
          <img src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
    </div>
  );
};

export default Rooms_block;
